import {Component, ElementRef, ViewChild} from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController,
  ViewController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable, Subject } from "rxjs";
import { AuthProvider } from "../../providers/auth/auth";
import * as moment from "moment";
import { AngularFirestore } from "@angular/fire/firestore";
import {OrderDetailsPage} from "../order-details/order-details";

@IonicPage()
@Component({
  selector: "page-admin-orders",
  templateUrl: "admin-orders.html"
})

export class AdminOrdersPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  status: string = "All";
  user: string;
  display_name: string;
  isLoading = false;

  rows: any[] = [];

  readonly pageLimit = 30;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private afs: AngularFirestore,
    private modalCtrl: ModalController,
    private el: ElementRef
  ) {
    this.auth.getCurrentUser().then(user => {
      this.user = user;
      this.display_name = user.display_name;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.roles.retina_admin || user.roles.retina_reporting? null : user.clinic_province;
      this.getOrders(this.pageLimit, null);
    });
  }

  ngOnDestroy() {
    console.log('Leave admin orders and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public isPrinted(row)  {
    if (row.last_printed) {
      return true;
    } else {
      return false;
    }
  }

  public formatDate(date) {
    let myMoment: moment.Moment;
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("MMM DD YYYY");
  }

  public getOrders(limit, lastOrder) {
    this.isLoading = true;
    this.database.getOrdersByTerritory(this.clinic_province, limit, lastOrder)
    .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          // data["doctor"]["full_name"] = data["doctor"]["first_name"] + " " + data["doctor"]["last_name"];
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe(orders => {
        this.rows = [...this.rows, ...orders];
        this.isLoading = false;
      });
  }

  openOrderDetails(order_id) {
    console.log(order_id);
    this.database.getOrder(order_id).valueChanges()
      .subscribe((order) => {
        console.log(order);
        this.navCtrl.push(OrderDetailsPage, {order: order});
      })
  }

  onScroll(event: any) {
    // check if we scrolled to the end of the viewport
    if (event.target && !this.isLoading && event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight) {
      // total number of results to load
      console.log("end");
      this.ngUnsubscribe.next();
      this.getOrders(this.pageLimit, this.rows[this.rows.length - 1].createdAt);
    }
  }

  openPrescriptionImage(orderId, imageUrl) {
   // let pad = this.modalCtrl.create(PrintModal, {id: null}, { cssClass: "signature-modal" });
   let pad = this.modalCtrl.create(PrintModal, {url: imageUrl, orderid: orderId },  { cssClass: "print-modal" });
    pad.onDidDismiss((data) => {
      
    });
    pad.present();
    // window.open(imageUrl, "_blank");
  }
  
}

@Component({
  selector: "page-print",
  template: `<ion-toolbar color="sentrex_blue\" style='min-height: 45px;'><ion-title>Print History</ion-title><ion-buttons end><button ion-button clear color='light' icon-only (click)="closePrintModal()">
    <ion-icon name='close'></ion-icon></button> </ion-buttons></ion-toolbar>
    <ion-row>
    <ion-col col-4><button block small ion-button color="sentrex_blue" (click)='openPDF()'>Open To Print</button></ion-col>
    </ion-row>
    <ion-list>
    <ion-item *ngFor="let item of printhistory">{{ item.user.first_name }} {{ item.user.last_name }} - {{ formatDate(item.createdAt) }}</ion-item>
</ion-list>
    `
})

export class PrintModal {
  viewCtrl: any;
  printhistory: any[] = [];
  imageUrl: string;
  orderId: string;
  user: any;
  constructor(private auth: AuthProvider, params: NavParams, viewCtrl: ViewController, private database: DatabaseProvider) {
    this.viewCtrl = viewCtrl;
    this.database = database;
    this.imageUrl = params.get("url");
    this.orderId = params.get("orderid");
    this.auth.getCurrentUser().then(user => {
      this.user = user;
    });

    this.getPrintHistory();
  }

  public formatDate(date) {
    if (date) {
      let myMoment: moment.Moment;
      if (date.seconds) {
        myMoment = moment.unix(date.seconds);
      } else {
        myMoment = moment(date);
      }
      return myMoment.format("MMM DD YYYY HH:mm:ss");
    } else {
      return null;
    }
  }

  closePrintModal() {
    this.viewCtrl.dismiss();
  }

  getPrintHistory() {
    this.database.getOrderPrintHistory(this.orderId).valueChanges().subscribe(history => {
      this.printhistory = history;
      console.log(history, this.printhistory);
    });
  }

  openPDF() {
    this.database.addOrderPrintHistory(this.orderId, this.user).then(() => {
      window.open(this.imageUrl, "_blank");
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-orders/admin-orders.ts